import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { OpenIdConnectService } from '../../services/oidc/open-id-connect.service';
import * as _errorHandler from '../../services/errorhandler';
import { UnitOfWorkService } from '../../services/unitOfWork/unitOfWork.service';

@Injectable({
    providedIn: 'root'
})
export class RequireAdminGuard implements CanActivate {
    constructor(private oidcService: OpenIdConnectService, private router: Router, private uow: UnitOfWorkService) { }

    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        var admin: boolean = next.data['admin'];

        if (admin) {
            return this.uow.authIsAdmin().then(data => {
                if (data && data.length > 0 && data[0])
                    return true;
                else
                    return false;
                })
                .catch(reason => {
                    return false;
                });
        }
        else {
            return true;
        }
    }
}
